import * as React from "react";

export const IconFileImport = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_31278_43346)">
        <path
          d="M11.6654 2.1665L4.9987 2.1665C4.08203 2.1665 3.34036 2.9165 3.34036 3.83317L3.33203 17.1665C3.33203 18.0832 4.0737 18.8332 4.99036 18.8332L14.9987 18.8332C15.9154 18.8332 16.6654 18.0832 16.6654 17.1665V7.1665L11.6654 2.1665ZM14.9987 17.1665H4.9987L4.9987 3.83317L10.832 3.83317V7.99984L14.9987 7.99984V17.1665Z"
          fill="#48A0B2"
        />
        <path
          d="M13.332 12.9918L12.157 11.8168L10.832 13.1335V9.66683H9.16536V13.1335L7.84036 11.8085L6.66536 12.9918L9.99036 16.3335L13.332 12.9918Z"
          fill="#48A0B2"
        />
      </g>
      <defs>
        <clipPath id="clip0_31278_43346">
          <rect width="20" height="20" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
